import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbNavChangeEvent, } from '@ng-bootstrap/ng-bootstrap';
import { UserModel } from 'src/app/core/models/members/user/user.model';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { GlobalComponent } from 'src/app/global-component';
import { RequisitionListService } from 'src/app/core/services/list-services/requisition-list.service';
// Sweet Alert
import Swal from 'sweetalert2';

import { ProductInfoModel, ProductType } from 'src/app/core/models/cart/product-info-model';

import { RequisitionListComponent } from 'src/app/shared/list-views/requisition-list/requisition-list.component';
import { AddressModel } from 'src/app/core/models/address.model';

import { CheckoutInfoModel } from 'src/app/core/models/cart/checkout-info-model';
import { CheckoutResultInfoModel } from 'src/app/core/models/cart/checkout-result-info-model';
import { CheckoutApiService } from 'src/app/core/services/checkout-api.service';
import { AccountTypeEnum } from 'src/app/core/enums/account-type-enum';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { Roles } from 'src/app/core/security/roles';
import { SettingsModel } from 'src/app/core/models/system/settings.model';
import { passwordComplexityOptions } from 'src/app/core/security/password-complexity-options.model';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
  providers: [RequisitionListService],
})
export class CheckoutComponent implements OnInit {
  @ViewChild('reqListComp') reqListComp?: RequisitionListComponent;

  emailPattern = GlobalComponent.emailPattern;

  // bread crumb items
  breadCrumbItems!: Array<{}>;
  submitted = false;

  userModel: UserModel = new UserModel();
  tabId: number = 1;
  isLoading: boolean = false;
  newCard: boolean = false;
  paymentComponent: any;

  checkoutDisabled: boolean = true;

  isGuest: boolean = false;
  settingsModel: SettingsModel = new SettingsModel;

  userNewPassword: string = '';
  userConfirmPassword: string = '';
  passwordNonValid: string | undefined = undefined;
  confirmPasswordNonValid: string | undefined = undefined;
  passwordFieldTextTypeNew: boolean = false;
  passwordFieldTextTypeConfirmation: boolean = false;

  constructor(private modalService: NgbModal,
    private toasterNotificationService: ToasterNotificationService,
    private checkoutApiService: CheckoutApiService,
    private myfileApiService: MyfileApiService,
    private authMyfileService: AuthMyfileService
  ) {

  }

  ngOnInit(): void {

    this.breadCrumbItems = [
      { label: 'Marketplace' },
      { label: 'Checkout', active: true }
    ];



    this.myfileApiService.getUser().subscribe((result: UserModel | undefined) => {
      if (result) {
        this.userModel = result;
        if (!this.userModel.paymentInfo.billingAddress) {
          this.userModel.paymentInfo.billingAddress = new AddressModel();
        }
        if (!this.userModel.fullName) {
          this.userModel.fullName = `${this.userModel.name} ${this.userModel.lastName}`
        }

        if (this.authMyfileService.isInRole(Roles.guest)) {
          this.isGuest = true;
          this.userModel.email = '';
          this.userModel.name = '';
          this.userModel.lastName = '';

          this.myfileApiService.getSystemPublicSettings().subscribe((result: SettingsModel) => {
            if (result) {
              this.settingsModel = result;
              if (this.settingsModel.passwordComplexityOptions == undefined) {
                this.settingsModel.passwordComplexityOptions = new passwordComplexityOptions();
              }
            }
          });
        }

      }
    });


  }

  validatePassword(): boolean {
    this.passwordNonValid = undefined;
    this.confirmPasswordNonValid = undefined;
    var isValid = true;

    if (this.userNewPassword != undefined && this.userNewPassword != '') {
      if (!(this.userNewPassword.length >= this.settingsModel.passwordComplexityOptions!.requiredLength)) {
        this.passwordNonValid = `Password needs to contain at least ${this.settingsModel.passwordComplexityOptions!.requiredLength} characters. `;
        isValid = false;
      }
      if (this.settingsModel.passwordComplexityOptions!.requireNonAlphanumeric && (this.userNewPassword.match(`(?=.*?[#?!@$%^&*-])`) == undefined)) {
        if (this.passwordNonValid === undefined) {
          this.passwordNonValid = '';
        }
        this.passwordNonValid = `${this.passwordNonValid}Password needs to contain at least one special (#?!@$%^&*-) character. `;
        isValid = false;
      }
      if (this.settingsModel.passwordComplexityOptions!.requireLowercase && (this.userNewPassword.match(`(?=.*?[a-z])`) == undefined)) {
        if (this.passwordNonValid === undefined) {
          this.passwordNonValid = '';
        }
        this.passwordNonValid = `${this.passwordNonValid}Password needs to contain at least one lowercase (a-z) character. `;
        isValid = false;
      }
      if (this.settingsModel.passwordComplexityOptions!.requireLowercase && (this.userNewPassword.match(`(?=.*?[A-Z])`) == undefined)) {
        if (this.passwordNonValid === undefined) {
          this.passwordNonValid = '';
        }
        this.passwordNonValid = `${this.passwordNonValid}Password needs to contain at least one uppercase (A-Z) character. `;
        isValid = false;
      }
      if (this.settingsModel.passwordComplexityOptions!.requireDigit && (this.userNewPassword.match(`(?=.*?[0-9])`) == undefined)) {
        if (this.passwordNonValid === undefined) {
          this.passwordNonValid = '';
        }
        this.passwordNonValid = `${this.passwordNonValid}Password needs to contain at least one number (0-9) character. `;
        isValid = false;
      }
    } else {
      this.passwordNonValid = $localize`:@@:New password is required`;
      isValid = false;
    }

    if (this.userConfirmPassword != undefined && this.userConfirmPassword != '') {
      if (!(this.userConfirmPassword !== undefined && this.userConfirmPassword !== '' && this.userConfirmPassword === this.userNewPassword)) {
        this.confirmPasswordNonValid = $localize`:@@Error_PasswordDNM:Password does not match`;
        isValid = false;
      }
    } else {
      this.confirmPasswordNonValid = $localize`:@@:Confirmation of password is required`;
      isValid = false;
    }

    return isValid;
  }

  ngAfterViewInit() {
    var sub = this.reqListComp?.totalChange.subscribe(() => {
      if (this.reqListComp?.requisitionsViewModel != null && this.reqListComp?.requisitionsViewModel!.length > 0) {
        this.checkoutDisabled = false;
      }
      sub!.unsubscribe();
    });
  }

  validatePersonalInfo(): boolean {

    if ((this.userModel.paymentInfo.billingAddress.postalCode) && (this.userModel.paymentInfo.billingAddress.postalCode.length == 6) && (!this.userModel.paymentInfo.billingAddress.postalCode.includes(" "))) {
      this.userModel.paymentInfo.billingAddress.postalCode = `${this.userModel.paymentInfo.billingAddress.postalCode.substring(0, 3)} ${this.userModel.paymentInfo.billingAddress.postalCode.substring(3, 6)}`;
    }
    if (
      this.userModel.paymentInfo.billingAddress.address1 && (this.userModel.paymentInfo.billingAddress.address1 != '') &&
      this.userModel.paymentInfo.billingAddress.streetNumber && (this.userModel.paymentInfo.billingAddress.streetNumber != '') &&
      this.userModel.paymentInfo.billingAddress.city && (this.userModel.paymentInfo.billingAddress.city != '') &&
      this.userModel.paymentInfo.billingAddress.province && (this.userModel.paymentInfo.billingAddress.province != '') &&
      this.userModel.paymentInfo.billingAddress.country && (this.userModel.paymentInfo.billingAddress.country != '') &&
      this.userModel.paymentInfo.billingAddress.postalCode && (this.userModel.paymentInfo.billingAddress.postalCode != '') && (this.userModel.paymentInfo.billingAddress.postalCode.length == 7) &&

      this.userModel.name && (this.userModel.name != '') &&
      this.userModel.lastName && (this.userModel.lastName != '') &&
      this.userModel.email != undefined && this.emailPattern.test(this.userModel.email) && this.userModel.email != ''
    ) {
      return true
    }
    this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Something went wrong. Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
    return false;
  }

  validateCreditCardInfo(): boolean {
    if (this.userModel.paymentInfo.expiryDate && this.userModel.paymentInfo.expiryDate.length > 5) {
      if (this.userModel.paymentInfo.expiryMonth && this.userModel.paymentInfo.expiryYear) {
        if (this.userModel.paymentInfo.expiryMonth < 10) {
          this.userModel.paymentInfo.expiryDate = `0${this.userModel.paymentInfo.expiryMonth}/${this.userModel.paymentInfo.expiryYear}`
        } else {
          this.userModel.paymentInfo.expiryDate = `${this.userModel.paymentInfo.expiryMonth}/${this.userModel.paymentInfo.expiryYear}`
        }
      }
    }

    if (this.userModel.paymentInfo.creditCardNumber && this.userModel.paymentInfo.creditCardNumber.length == 15 || 16 && !this.userModel.paymentInfo.creditCardNumber.includes(' ')) {
      this.userModel.paymentInfo.creditCardNumber = `${this.userModel.paymentInfo.creditCardNumber.substring(0, 4)} ${this.userModel.paymentInfo.creditCardNumber.substring(4, 8)} ${this.userModel.paymentInfo.creditCardNumber.substring(8, 12)} ${this.userModel.paymentInfo.creditCardNumber.substring(12, this.userModel.paymentInfo.creditCardNumber.length)}`
    }

    if (
      this.userModel.paymentInfo.cardHolderName && (this.userModel.paymentInfo.cardHolderName != '') &&
      this.userModel.paymentInfo.creditCardNumber && (this.userModel.paymentInfo.creditCardNumber != '') && (this.userModel.paymentInfo.creditCardNumber.length == 18 || 19) &&
      this.userModel.paymentInfo.cvvNumber && (this.userModel.paymentInfo.cvvNumber.length >= 3) &&
      this.userModel.paymentInfo.expiryDate && (this.userModel.paymentInfo.expiryDate.length == 5)
    ) {
      this.userModel.paymentInfo.expiryMonth = parseInt(this.userModel.paymentInfo.expiryDate.split('/')[0])
      this.userModel.paymentInfo.expiryYear = 2000 + parseInt(this.userModel.paymentInfo.expiryDate.split('/')[1])
      return true
    } else {
      return false
    }
  }

  tabToPayment() {

    this.submitted = true;
    var requisitions = this.reqListComp?.requisitionsViewModel;
    if (requisitions && requisitions.length > 0) {
      var isValid: boolean = true;
      if (this.isGuest) {
        if (this.validatePassword() == false) {
          isValid = false;
        }
      }

      if (this.validatePersonalInfo() && isValid) {
        this.userModel.fullName = `${this.userModel.name} ${this.userModel.lastName}`;
        if (!this.userModel.paymentInfo.creditCardNumber) {
          this.newCard = true;
        }
        if (this.isGuest) {

          this.userModel.password = this.userConfirmPassword;
          this.userModel.userName = this.userModel.email;
          
          this.myfileApiService.updateUser(this.userModel).subscribe((userUpdateResult: any) => {
            if (userUpdateResult) {
              this.submitted = false;
              this.tabId = 2;
            }
          });
        } else {
          this.submitted = false;
          this.tabId = 2;
        }


      }
    }
    else {
      Swal.fire({
        title: $localize`:@@:Checkout`,
        text: $localize`:@@:Your cart is empty. Please add items to your cart before proceeding.`,
        icon: 'warning',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Ok`,
      });
    }
  }

  tabToInfo() {
    this.tabId = 1;
  }

  tabToFinish() {
    this.submitted = true;
    this.isLoading = true;
    if (this.validateCreditCardInfo()) {
      this.myfileApiService.isCreditCardValid(this.userModel.paymentInfo).subscribe((ccValidationResult: any) => {
        if (ccValidationResult) {
          Swal.fire({
            title: $localize`:@@:Checkout`,
            text: $localize`:@@:Your credit card will not be charged until your Requisitions are processed by the MyFile Team. Do you want to proceed?`,
            icon: 'warning',
            color: 'var(--vz-body-color)',
            background: 'var(--vz-body-bg)',
            showCancelButton: true,
            confirmButtonColor: 'rgb(3, 142, 220)',
            cancelButtonColor: 'rgb(243, 78, 78)',
            confirmButtonText: $localize`:@@:Ok`,
            cancelButtonText: $localize`:@@:Cancel`,
          }).then(result => {
            if (result.isConfirmed && this.reqListComp != null) {
              this.myfileApiService.updateUser(this.userModel).subscribe((userUpdateResult: any) => {
                if (userUpdateResult) {

                  var checkoutInfo = new CheckoutInfoModel();

                  var requisitions = this.reqListComp?.requisitionsViewModel;

                  for (var i = 0; requisitions != null && i < requisitions.length; i++) {
                    var productInfo = new ProductInfoModel();
                    productInfo.productType = ProductType.Requisition;
                    productInfo.productId = requisitions[i].id;

                    checkoutInfo.products.push(productInfo);
                  }

                  this.checkoutApiService.cartCheckout(checkoutInfo).subscribe((result: CheckoutResultInfoModel | undefined) => {
                    if (result) {
                      this.reqListComp?.clearRequisitionList();
                      this.tabId = 3;
                    }
                    else {
                      //handle error
                      this.toasterNotificationService.showError($localize`:@@Toast_Error_CartCheckoutFailed: Please check your Draft requisitions for validity and try again.`, $localize`:@@Toast_Error_CartCheckoutFailedTitle: Cart Checkout Failed`);
                    }
                  });
                }
                this.submitted = false;
                this.isLoading = false;
              });
            } else {
              this.isLoading = false;
            }
          });
        } else {
          this.isLoading = false;
        }
      })
    } else {
      this.isLoading = false;
    }
  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    if (changeEvent.nextId == (2)) {
      changeEvent.preventDefault();
    }
    if (changeEvent.nextId == (3)) {
      changeEvent.preventDefault();
    }
  }
}
